import styled from 'styled-components';

const ContainerItem = styled.div<{
  isBorder?: boolean;
}>`
  margin-top: 20px;
  border: ${({ isBorder, theme }) =>
    isBorder ? `1px solid ${theme.palette.gray87}` : 'none'};

  &:not(:first-child) {
    &.containerItem__header {
      margin-top: 40px;
    }
  }
`;

export default ContainerItem;
